import styled from "styled-components";

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: 1200px) {
    margin: -25px 0 0;
  }
  @media screen and (min-width: 1439) {
    margin: -25px;
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 32px 32px 80px 32px;
`;
